import BaseNotificationSetting from "@/models/server/notification/BaseNotificationSetting";
import User from "@/models/server/User";

export default class GlobalNotificationSetting extends BaseNotificationSetting {
    public id: string = "";

    public receivers: User[] = [];

    public isGlobalNotificationSetting: boolean = true;
}